/* eslint-disable no-underscore-dangle */
import TYPES from './types.js'
import _$ from 'js/api/getdata.js'
import Cookie from 'js/lib/cookie.js'

window.TYPES = TYPES

/**
 * 获取当前语言
 * @param commit
 * @param state
 */
export const getLanguage = ({ commit, state }) => {
    let language = localStorage.getItem('language') ||  Cookie.get('language') ||  (navigator.language || navigator.browserLanguage).toLowerCase().substr(0, 2)
    commit(TYPES.GET_LENOVO_LANGUAGE, language)
}

/**
 * 获取当前用户信息
 * @param commit
 * @param state
 */
export const getUserInfo = ({ commit, state }) => {
    _$.getData('getUserInfo', null, (res) => {
        commit(TYPES.GET_USER_INFO, res.data)
    })
}

/**
 * 获取当前账户信息
 * @param commit
 * @param state
 */
export const getAccountInfo = ({ commit, state }) => {
    _$.getData('getAccountInfo', null, (res) => {
        commit(TYPES.GET_LENOVO_ACCOUNT_INFO, res.data)
    })
}

/**
 * 获取当前自定义信息
 * @param commit
 * @param state
 */
export const getCustomizeInfo = ({ commit, state }) => _$.getData('getCustomizeInfo', null, (res) => {
    commit(TYPES.GET_LENOVO_CUSTOMIZE_INFO, res.data)
})

/**
 * 获取SESSION
 * @param commit
 * @param state
 */
export const getSession = ({ commit, state }, context) => new Promise((resolve, reject) => {
    _$.getData('getSession', null, (res) => {
        commit(TYPES.GET_SESSION, res.data);
        resolve(res.data);
    })
})
/**
 * 获取当前用户角色
 * @param commit
 * @param state
 */
export const getUserRole = ({commit, state}) => _$.getData('getUserRole', null).then((res) => {
    commit(TYPES.GET_USER_ROLE, res.data)
})



// WEBPACK FOOTER //
// ./store/actions.js